module.exports = __webpack_public_path__ + "5574440f6a6b2244797eeaca92c8cc37.svg";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/history/clock-gray.svg
// module id = 840
// module chunks = 0